import React, {CSSProperties} from "react";
import {observer} from "mobx-react";
import {ISegmentViewModel} from "../../../services/booking/models/segment/segment-view-model.interface";
import {useServices} from "../../../hooks/use-services.hook";
import {TicketSegmentFlightDetailsComponent} from "./ticket-segment-flight-details.component";
import {TicketStationComponent} from "../common/ticket-station.component";


export const TicketSegmentDetailsComponent: React.FC<{segment: ISegmentViewModel}> = observer((props) => {
    const services = useServices();
    const rootStyles: CSSProperties = {
        pageBreakInside: "avoid",
        breakInside: "avoid"
    }

    const gridStyles: CSSProperties = {
        display: 'grid',
        gridTemplateColumns: '1fr 3fr 1fr',
        padding: `${services.theme.currentTheme.spacing.cardDefaultPadding}`,
        backgroundColor: services.theme.currentTheme.colors.light,
        border: `1px solid ${services.theme.currentTheme.border.mainColor}`,
        borderRadius: services.theme.currentTheme.border.defaultRadius
    };


    return (
        <div style={rootStyles}>
            <div style={gridStyles}>
                <TicketStationComponent station={props.segment.designator.origin}
                                  departureDate={props.segment.designator.formatDepartureDate()}
                                  departureTime={props.segment.designator.formatDepartureTime()}/>
                <TicketSegmentFlightDetailsComponent segment={props.segment}/>
                <TicketStationComponent station={props.segment.designator.destination}
                                  departureDate={props.segment.designator.formatArrivalDate()}
                                  departureTime={props.segment.designator.formatArrivalTime()}/>
            </div>
        </div>
    )
})